module.exports = __webpack_public_path__ + "img/sit.15113853.png";